import { GIFT_CATALOGUE as GCHOME_DATALAYER } from '../../datalayer/data/gift_catalogue.js';

function last_item(arr) {
    return arr[arr.length - 1];
}

export function update_datalayer(
    product,
    is_promo,
    position,
    collection_title,
    product_price,
    img_url,
    featured
) {
    // GCHOME_DATALAYER.isPromo = is_promo;
    // GCHOME_DATALAYER.pageType = 'product list';
    GCHOME_DATALAYER.id.push(product.id.toString());
    GCHOME_DATALAYER.name.push(product.title);
    GCHOME_DATALAYER.category.push(`Gifts/${collection_title}`);
    GCHOME_DATALAYER.variant.push('');
    GCHOME_DATALAYER.name.push('Featured Gift Products List');

    // TODO: This is not assigned to utag_data, should this be?
    // Liquid expression: {{ product.variants[0].price | money_without_currency | json }}
    // GCHOME_DATALAYER.price.push(product_price);

    // TODO: This is not assigned to utag_data, should this be?
    // GCHOME_DATALAYER.productArrayListPosition.push(position);

    if (is_promo === 'true') {
        GCHOME_DATALAYER.promo_id.push(product.id.toString());
        GCHOME_DATALAYER.promo_name.push(product.title);

        // {{ featuredProduct.images[0] | img_url: "medium" | json }}
        GCHOME_DATALAYER.promo_creative.push(img_url);

        GCHOME_DATALAYER.promo_position.push(position);
    } else {
        GCHOME_DATALAYER.promo_id.push('');
        GCHOME_DATALAYER.promo_name.push('');
        GCHOME_DATALAYER.promo_creative.push('');
        GCHOME_DATALAYER.promo_position.push('');
    }

    if (featured) {
        let dataobj = GCHOME_DATALAYER;
        dataobj.impression_id.push(last_item(dataobj.id));
        dataobj.impression_name.push(collection_title);
        dataobj.impression_category.push(last_item(dataobj.category));
        dataobj.impression_list_variant.push(last_item(dataobj.variant));
        dataobj.impression_price.push(product_price);
        dataobj.impression_list_name.push(last_item(dataobj.name));
        dataobj.impression_position.push(position);
    }
}

export function update_cards_datalayer(collection, img_url) {
    GCHOME_DATALAYER.promo_id.push(collection.id);
    GCHOME_DATALAYER.promo_name.push(collection.title);

    // {{ metafield['hero-image'] | replace: '.jpg', '_675x.jpg' }}
    GCHOME_DATALAYER.promo_creative.push(img_url);

    let curlen = GCHOME_DATALAYER.promo_position.length;
    GCHOME_DATALAYER.promo_position.push(curlen + 1);
}
